"use client";

import { usePathname } from "next/navigation";
import PageHeader from "@/components/layout/page-header";

const paths: Record<string, string> = {
  "/profile/article": "Makale",
  "/profile/forum": "Forum",
  "/profile/names": "Favori İsimler",
  "/profile/quiz": "Quiz",
  "/profile/tv": "TV",
};
const HeaderWrapper = () => {
  const pathName = usePathname();
  return <PageHeader title={paths[pathName] || "Makale"} />;
};

export default HeaderWrapper;
